import { AppAlert } from '@components/antd';
import { useSupportChat } from '@shared/hooks/use-support-chat';
import { Trans } from 'react-i18next';

export const CallNotSupportedBanner = () => {
  const { openSupportChat } = useSupportChat();
  return (
    <AppAlert
      showIcon
      type="error"
      message={
        <p>
          <Trans
            i18nKey="call_not_supported_some_third_party_tools_might_be_affecting_try_removing_it_or_contact_customer_support"
            components={[
              <span key="support-link" className="cursor-pointer text-amber-700" onClick={openSupportChat}></span>,
            ]}
          />
        </p>
      }
    />
  );
};
